import $axios from '../api.js'

const state = () => ({
    questions: localStorage.getItem('activity_social') ? JSON.parse(localStorage.getItem('activity_social')).questions : [],
    answers: localStorage.getItem('activity_social') ? JSON.parse(localStorage.getItem('activity_social')).answers : [],
    questionIndex: localStorage.getItem('activity_social') ? JSON.parse(localStorage.getItem('activity_social')).questionIndex : 0,
    bar_active: localStorage.getItem('activity_social') ? JSON.parse(localStorage.getItem('activity_social')).bar_active : Array(),
    bar_visited: localStorage.getItem('activity_social') ? JSON.parse(localStorage.getItem('activity_social')).bar_visited : Array(),
    answerCheck: localStorage.getItem('activity_social') ? JSON.parse(localStorage.getItem('activity_social')).answerCheck : Array(),
    instruction: localStorage.getItem('activity_social') ? JSON.parse(localStorage.getItem('activity_social')).instruction : Array(),
    questionResponses: localStorage.getItem('activity_social') ? JSON.parse(localStorage.getItem('activity_social')).questionResponses : Array(),
    step: localStorage.getItem('activity_social') ? JSON.parse(localStorage.getItem('activity_social')).step : 1,
    is_finish: localStorage.getItem('activity_social') ? JSON.parse(localStorage.getItem('activity_social')).is_finish : 0,
    intro: localStorage.getItem('activity_social') ? JSON.parse(localStorage.getItem('activity_social')).intro : true,
    show_question: localStorage.getItem('activity_social') ? JSON.parse(localStorage.getItem('activity_social')).show_question : 5,

})

const mutations = {
    //MEMASUKKAN DATA KE STATE OUTLETS
    ASSIGN_DATA(state, payload) {
        state.questions = payload.data
        state.instruction = payload.instruction[0];
    },
    //MEMASUKKAN DATA KE STATE OUTLETS
    ASSIGN_DATA_ACTIVITY(state, payload) {
        state.questionIndex = payload.questionIndex;
        state.bar_active= payload.bar_active;
        state.bar_visited= payload.bar_visited;
        state.answerCheck= payload.answerCheck;
        state.questionResponses= payload.questionResponses;
        state.step= payload.step;
        state.intro= payload.intro;
        state.questions = payload.questions;
        state.show_question = payload.show_question;
        localStorage.setItem('activity_social', JSON.stringify(state))
    },
    ASSIGN_ANSWER_USER(state,payload){
        if (payload.length > 1) {
            state.intro = false;
            state.questionResponses = payload;
            state.questionIndex = payload.length;
            state.step = Number( (payload.length / state.show_question) + 2).toFixed(0);
            localStorage.setItem('activity_social', JSON.stringify(state))
        }

    }
}

const actions = {
    //FUNGSI INI UNTUK MELAKUKAN REQUEST DATA QUESTIONS DARI SERVER
    getQuestions({ commit, state }, payload) {
        return new Promise((resolve, reject) => {
            //REQUEST DATA DENGAN ENDPOINT /OUTLETS
            $axios.get(`/questions?lang=${payload.lang}&type=${payload.type}`)
                .then((response) => {
                    //SIMPAN DATA KE STATE MELALUI MUTATIONS
                    let data = {
                        data : response.data.data,
                        instruction: response.data.instruction
                    };
                    commit('ASSIGN_DATA', data)
                    resolve(response.data)
                })
        })
    },
    async next({ commit, state, dispatch }, payload){

        state.bar_visited[state.step] = true;
        var re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        var last_index = 1;
        for (let i=state.questionIndex;i<state.questionIndex+state.show_question;i++){

            if (state.questionResponses[i] == null && i < state.questions.length ){
                let pesan = localStorage.lang == 'id' ? 'Silahkan menjawab pertanyaan untuk maju' : 'Please answer the question to continue'

                alert(pesan)
                state.required = true;
                break;
            }else{
                if (i >= state.questions.length -1){
                    state.is_finish = 1;
                    commit('ASSIGN_DATA_ACTIVITY', state);
                    await dispatch('submitAnswer', {
                        lang: localStorage.lang,
                        type: 'D',
                        client_id : localStorage.client_id,
                        is_finish: state.is_finish,
                        answer: state.questionResponses
                    },{root: true})
                    commit('SET_SECTION', 5, { root: true });
                    break;
                }
                last_index = i;
                state.required = false;
            }
        }

        if (state.required == false){
            state.step++;
            state.required = false;

            state.questionIndex = last_index+1;
            state.bar_active[state.step] = true;
            state.bar_visited[state.step] = false;
        }

        state.loading = false;
        commit('ASSIGN_DATA_ACTIVITY', state);
        await dispatch('submitAnswer', {
            lang: localStorage.lang,
            type: 'D',
            client_id : localStorage.client_id,
            is_finish: state.is_finish,
            answer: state.questionResponses
        },{root: true});


    },
    nextIntro({ commit, state }, payload){

        state.bar_visited[state.step] = true;
        state.answerCheck[state.questionIndex] = true;
            if (state.questionStep == false) {
                state.ProductiveCheck[state.questionIndex] = true;
            }
        state.questionIndex++;
        state.step++;

            if (state.questionIndex === state.questions.length) {
                state.questionStep = false;
            }

        state.bar_active[state.step] = true;
        state.bar_visited[state.step] = false;
        state.intro = false;
            commit('ASSIGN_DATA_ACTIVITY', state)
    },
    logout({ commit }, payload) {
        localStorage.clear(); //RESET LOCAL STORAGE MENJADI NULL
        commit('SET_TOKEN', null, { root: true }) //RESET STATE TOKEN MENJADI NULL
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}
